const API_VER_V2 = 'v2.0'
const API_VER = 'v1.0'
export const HREndpoints = {
    HR_EMPLOYEE_URI: `/hr/api/${API_VER_V2}/employees/`,
    HR_DEPARTMENT_URI: `/hr/api/${API_VER}/departments/`,
    HR_EMPLOYEE_NOT_IN_DEVICE: `/hr/api/${API_VER_V2}/employees/inactive_list/?deviceId=`,
    HR_RESIGNATNION_URI: `/hr/api/${API_VER_V2}/resignations/`,
}
